import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import './MainPage.module.css';
import './MainPage.css';
import './General.css';

import ErrorPage from './ErrorPage';

class Counter extends React.Component {
  constructor() {
    super();
    this.state = {
      uuid: '',
      logo: '',
      count: 0,
      isError: false,
      error: {}
    };

    this.incrementCount = this.incrementCount.bind(this);
    this.getUuidFromLocaleStorage = this.getUuidFromLocaleStorage.bind(this);
    this.getLogoFromLocaleStorage = this.getLogoFromLocaleStorage.bind(this);
    this.getOriginalScoreFromApi = this.getOriginalScoreFromApi.bind(this);
  }

  getUuidFromLocaleStorage() {
    const uuid = localStorage.getItem('uuid');
    this.getOriginalScoreFromApi(uuid);
    this.setState({ uuid: uuid });
  }

  getLogoFromLocaleStorage() {
    const logo = localStorage.getItem('logoOpponent');
    this.setState({ logo: logo });
  }

  getOriginalScoreFromApi(uuid) {
    axios
      .get(`https://c-clicker-api.herokuapp.com/users/${uuid}`)
      .then(res => {
        const datas = res.data;
        this.setState({ count: datas.score });
      })
      .catch(err => {
        console.log(err);
        this.setState({ isError: true, error: err });
      });
  }

  componentDidMount() {
    this.getUuidFromLocaleStorage();
    this.getLogoFromLocaleStorage();
  }

  incrementCount() {
    axios
      .put(`https://c-clicker-api.herokuapp.com/users/${this.state.uuid}/click`)
      .then(res => {
        const newCount = this.state.count + 1;
        this.setState({ count: newCount });
      })
      .catch(err => {
        console.log(err);
        this.setState({ isError: true, error: err });
      });
  }

  render() {
    const { count, logo, isError, error } = this.state;

    if (isError) {
      return <ErrorPage error={error} />;
    } else {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <h1 className="counter">{count}</h1>

          <img
            className="logoOpponent mb-4"
            src={logo}
            alt="logo team"
            onClick={this.incrementCount}
          />

          <Link to="/changeOpponent">
            <Button outline color="warning" className="p-light mb-3">
              Changer de team à boxer
            </Button>
          </Link>
        </div>
      );
    }
  }
}

export default Counter;
